export const BATTERY_PART_TYPE = 'BATTERY';
